import { Link } from 'react-router-dom'
import { Database } from 'lucide-react'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { useTopQueries, useTableStats, useSlowLog, useDbPerfConfig } from '@/hooks/useDbPerf'

function Row({ label, value, ok }: { label: string; value: string; ok: boolean }) {
  return (
    <div className="flex justify-between text-xs">
      <dt className="text-muted-foreground">{label}</dt>
      <dd className={ok ? 'text-emerald-500' : 'text-amber-500'}>{value}</dd>
    </div>
  )
}

export function DbPerfSummaryCard() {
  const top = useTopQueries()
  const stats = useTableStats()
  const slow = useSlowLog(50, '15m')
  const cfg = useDbPerfConfig()

  const topMean = Math.round(top.data?.[0]?.mean_exec_time_ms ?? 0)
  const floor = Number(cfg.data?.db_perf_seq_scan_ratio_floor ?? '0.5')
  const tablesOver = stats.data?.filter((t) => t.seq_scan_ratio > floor).length ?? 0
  const tableCount = stats.data?.length ?? 0
  const slowCount = slow.data?.length ?? 0

  const topOk = topMean < 500
  const tablesOk = tablesOver === 0
  const slowOk = slowCount < 10

  return (
    <Link to="/admin/db/perf" className="block">
      <Card className="h-full hover:bg-muted/30 transition-colors cursor-pointer">
        <CardHeader className="flex flex-row items-center justify-between pb-2">
          <CardTitle className="text-sm font-medium flex items-center gap-2">
            <Database className="h-4 w-4" />
            DB Perf
          </CardTitle>
          <span className="text-xs text-muted-foreground">→</span>
        </CardHeader>
        <CardContent>
          {top.isLoading ? (
            <p className="text-xs text-muted-foreground">Loading...</p>
          ) : (
            <dl className="space-y-1">
              <Row
                label="Top query mean"
                value={topMean > 0 ? `${topMean}ms` : '—'}
                ok={topOk}
              />
              <Row
                label="Tables &gt; ratio floor"
                value={`${tablesOver} / ${tableCount}`}
                ok={tablesOk}
              />
              <Row
                label="Slow queries (15m)"
                value={String(slowCount)}
                ok={slowOk}
              />
            </dl>
          )}
        </CardContent>
      </Card>
    </Link>
  )
}
